import { SELECTED_STATUS } from '~/modules/billing-invoicing/common/components/BillingTransactionTab/enums';

export const getSelectedItemsCount = ({
  allSelectedStatus,
  totalCount,
  excludedItems,
  selectedItems
}) => {
  if (allSelectedStatus === SELECTED_STATUS.ALL) {
    return totalCount - excludedItems.length;
  }

  return selectedItems.length;
};

export const getSyncBillsInputProps = ({
  selectedItems,
  allSelectedStatus,
  excludedItems,
  billingTransactionFilter
}) => {
  if (allSelectedStatus === SELECTED_STATUS.ALL) {
    const transactionTypes =
      billingTransactionFilter && billingTransactionFilter.transactionTypes
        ? billingTransactionFilter.transactionTypes.filter(x => x === 'BILL')
        : ['BILL'];

    const excludedBillIds = excludedItems
      .filter(x => x.type === 'BILL')
      .map(x => x.id);

    return {
      isAllSelected: true,
      includedBillIds: [],
      excludedBillIds,
      filter: billingTransactionFilter
        ? { ...billingTransactionFilter, transactionTypes }
        : { transactionTypes },
      billIdsForSync: [],
      billIdsForIssue: []
    };
  }
  const selectedBillIds = selectedItems
    .filter(x => x.type === 'BILL')
    .map(x => x.id);

  const selectedBillIdsForSync = selectedItems
    .filter(x => x.type === 'BILL' && x.billStatus === 'BILLED')
    .map(x => x.id);

  const selectedBillIdsForUpdateStatus = selectedItems
    .filter(x => x.type === 'BILL' && x.billStatus !== 'BILLED')
    .map(x => x.id);

  return {
    isAllSelected: false,
    includedBillIds: selectedBillIds,
    excludedBillIds: [],
    filter: {},
    billIdsForSync: selectedBillIdsForSync,
    billIdsForIssue: selectedBillIdsForUpdateStatus
  };
};

export const mapToBillingTransactionFilter = ({
  filter: {
    clients: clientUris,
    transactionTypes,
    dateRange,
    text,
    balanceStatusList,
    isOverdue,
    dueDate,
    billingTransactionUris
  } = {}
}) => ({
  clientUris: clientUris || [],
  transactionTypes,
  dateRange,
  searchTerm: text,
  balanceStatusList,
  isOverdue,
  dueDate,
  billingTransactionUris: billingTransactionUris || []
});
